import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Pagination, Navigation]);

const initEducationLargeSlider = () => {
  const slider = document.querySelector(".education-slider--large");

  slider &&
    new Swiper(slider, {
        autoHeight: false,
        loop: false,
        lazy: true,
        spaceBetween: 15,
        breakpoints: {
          0: {
            slidesPerView: 1
          },
          360: {
            slidesPerView: 1.2
          },
          665: {
            slidesPerView: 2
          },
          751: {
            slidesPerView: 4
          }
        },
        pagination: {
          el: ".education .education-pagination",
          bulletActiveClass: "active",
          clickable: true,
        },
    });
};

export default initEducationLargeSlider;
